var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglebutton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_170_675)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.0301 8.16138C15.0301 7.64172 14.9834 7.14204 14.8968 6.66235H7.99463V9.50051H11.9387C11.7655 10.4132 11.2458 11.1861 10.4664 11.7057V13.5512H12.8448C14.2306 12.272 15.0301 10.3933 15.0301 8.16138Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99456 15.3233C9.97327 15.3233 11.6322 14.6704 12.8447 13.5511L10.4663 11.7056C9.81338 12.1453 8.98059 12.4118 7.99456 12.4118C6.08913 12.4118 4.47019 11.126 3.89056 9.3938H1.45215V11.2859C2.65803 13.6777 5.12976 15.3233 7.99456 15.3233Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.89059 9.38716C3.74401 8.94745 3.6574 8.48109 3.6574 7.99474C3.6574 7.50839 3.74401 7.04202 3.89059 6.60231V4.71021H1.45217C0.952496 5.69623 0.666016 6.80884 0.666016 7.99474C0.666016 9.18063 0.952496 10.2932 1.45217 11.2793L3.35094 9.80023L3.89059 9.38716Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99456 3.58436C9.07386 3.58436 10.0332 3.95745 10.7994 4.67698L12.898 2.57835C11.6255 1.39245 9.97327 0.66626 7.99456 0.66626C5.12976 0.66626 2.65803 2.31186 1.45215 4.7103L3.89056 6.6024C4.47019 4.87019 6.08913 3.58436 7.99456 3.58436Z",
    fill: "#EA4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_170_675"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.9896,
    height: 15.9896,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglebutton);
export default __webpack_public_path__ + "static/media/googlebutton.d37e6b11cc38deb418c9735636fa0afb.svg";
export { ForwardRef as ReactComponent };